module.exports = __webpack_public_path__ + "img/erica-armstrong-dunbar.5039b9f7.png";